import { createAction, createSlice } from '@reduxjs/toolkit';

export const addPhoneNumberRequest = createAction('businessOnboarding/addPhoneNumberRequest');
export const verifyPhoneNumberRequest = createAction('businessOnboarding/verifyPhoneNumberRequest');
export const setBusinessOnboardingStep = createAction('businessOnboarding/setBusinessOnboardingStep');

const initialState = {
  loading: false,
  success: false,
  error: null,
  phoneNumber: '',
  message: '',
  step: 'PHONE',
};

const businessOnboardingSlice = createSlice({
  name: 'businessOnboarding',
  initialState,
  reducers: {
    addPhoneNumberStart: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    addPhoneNumberSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = null;
      state.phoneNumber = action.payload.phoneNumber;
      state.message = action.payload.message;
      state.step = 'OTP';
    },
    verifyPhoneNumberStart: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    verifyPhoneNumberSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = null;
      state.message = action.payload.message;
      state.step = 'COMPLETE';
    },
    addPhoneNumberFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload || 'Failed to add phone number';
    },
    verifyPhoneNumberFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload || 'Failed to verify phone number';
    },
    setBusinessOnboardingStep: (state, action) => {
      state.step = action.payload || 'PHONE';
    },
    resetBusinessOnboarding: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.phoneNumber = '';
      state.message = '';
      state.step = 'PHONE';
    }
  }
});

export const {
  addPhoneNumberStart,
  addPhoneNumberSuccess,
  addPhoneNumberFailure,
  verifyPhoneNumberStart,
  verifyPhoneNumberSuccess,
  verifyPhoneNumberFailure,
  resetBusinessOnboarding,
} = businessOnboardingSlice.actions;

export default businessOnboardingSlice.reducer;
